import cx from 'classnames'
import { BillingFrequency } from '../../UpgradePlanModal'

import Styles from './BillingFrequencyRadioButtons.module.scss'

interface Props {
  billingFrequency: BillingFrequency
  setBillingFrequency: (frequency: BillingFrequency) => void
}

export const BillingFrequencyRadioButtons = ({ billingFrequency, setBillingFrequency }: Props) => {
  return (
    <div className={Styles.billingFrequency}>
      <div className={Styles.billAnnually} onClick={() => setBillingFrequency('year')}>
        <div className={cx(Styles.radioButton, { [Styles.selected]: billingFrequency === 'year' })}>
          {billingFrequency === 'year' && <div className={Styles.indicator}></div>}
        </div>
        <span>Billed annually</span>
        <p className={Styles.savings}>Save 25%</p>
      </div>
      <div className={Styles.billMonthly} onClick={() => setBillingFrequency('month')}>
        <div className={cx(Styles.radioButton, { [Styles.selected]: billingFrequency === 'month' })}>
          {billingFrequency === 'month' && <div className={Styles.indicator}></div>}
        </div>
        <span>Billed monthly</span>
      </div>
    </div>
  )
}
